import React, { Component } from 'react'

export default function (ComposedComponent) {
  class PreviewController extends Component {
    constructor (props) {
      super(props)
      this.bindPreview = this.bindPreview.bind(this)
      this.state = { preview: 'messenger' }
    }

    bindPreview (preview) {
      return (e) => {
        if (preview !== this.state.preview) {
          this.setState({ preview })
        }
      }
    }

    render () {
      return (
        <ComposedComponent
          {...this.props}
          {...this.state}
          bindPreview={this.bindPreview}
        />
      )
    }
  }

  return PreviewController
}



// WEBPACK FOOTER //
// ./src/channel/appearance/preview/PreviewController.js